/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateScreenerBedUnitRankRequest
 */
export interface UpdateScreenerBedUnitRankRequest {
    /**
     * The facility the bed unit belongs to
     * @type {string}
     * @memberof UpdateScreenerBedUnitRankRequest
     */
    facility_id: string;
    /**
     * The current rank of the bed unit
     * @type {number}
     * @memberof UpdateScreenerBedUnitRankRequest
     */
    current_rank: number;
    /**
     * The new rank to assign to the bed unit
     * @type {number}
     * @memberof UpdateScreenerBedUnitRankRequest
     */
    new_rank: number;
}

/**
 * Check if a given object implements the UpdateScreenerBedUnitRankRequest interface.
 */
export function instanceOfUpdateScreenerBedUnitRankRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "current_rank" in value;
    isInstance = isInstance && "new_rank" in value;

    return isInstance;
}

export function UpdateScreenerBedUnitRankRequestFromJSON(json: any): UpdateScreenerBedUnitRankRequest {
    return UpdateScreenerBedUnitRankRequestFromJSONTyped(json, false);
}

export function UpdateScreenerBedUnitRankRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScreenerBedUnitRankRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'current_rank': json['current_rank'],
        'new_rank': json['new_rank'],
    };
}

export function UpdateScreenerBedUnitRankRequestToJSON(value?: UpdateScreenerBedUnitRankRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'current_rank': value.current_rank,
        'new_rank': value.new_rank,
    };
}

